<div class="search-wrapper">
  <mat-icon>search</mat-icon>
  <input
    #searchInput
    (input)="emitSearchChange($event)"
    placeholder="{{ placeholder() }}"
    type="text"
  />
</div>
<ng-content></ng-content>
